import React, { useCallback, memo,useState } from "react";

import moment from "moment";

import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import "./index.css";

const DateWrapp = styled(DesktopDatePicker)(({ theme, warning }) => ({
  border: `1px solid ${warning ? 'red' : 'white'}`,
  width: "142px",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    width: "251px",
  },
  "& .MuiInputBase-root": {
    height: "44px",
    paddingRight: "10px",
    fontFamily: "Proxima Nova",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.187,
    color: "#1a1a1a",
    input: {
      marginRight:'-15px',
      cursor:'pointer',
      "&::placeholder": {
        color: "#1a1a1a",
        opacity: 1,
      },
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2bb656",
    },
    [theme.breakpoints.up("sm")]: {
      paddingRight: "12px",
      fontSize: "14px",
      lineHeight: "1.214",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 0 12px 10px ",
    [theme.breakpoints.up("sm")]: {
      padding: "14px 0 14px 12px ",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d9d9d9",
  },
}));

const DatePickerComponent = memo(({ date, setDate, setTime, setDateNotEmpty, warning, isMobile }) => {
  const [open, setOpen] = useState(false)
  const handleChange = useCallback(
    (newValue) => {
      setTime("");
      setDate(newValue);
      setDateNotEmpty(false)
    },
    [setDate, setTime, setDateNotEmpty]
  );

  
    

    const disableInput = useCallback(event => {
        event.preventDefault()
    },[])


    

  return (
    <DateWrapp
      warning={warning}
      autoOk={true}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setTimeout(() => setOpen(false), 500) }
      value={open ? date : null}
      onChange={handleChange}
      showToolbar={false}
      minDate={moment().add(1, "days")}
      renderInput={(params) => (
        <TextField
          {...params}
          onClick={(e) => setOpen(true)}
          onKeyDown={disableInput}
          inputProps={{
            ...params.inputProps,
            placeholder: !date ? 'Choose date' : isMobile ?  moment(date).format("MMM DD, YYYY") : moment(date).format("MMMM DD, YYYY"),
          }}
        />
      )}
      components={{
        LeftArrowIcon: ArrowBackIcon,
        RightArrowIcon: ArrowForwardIcon,
        OpenPickerIcon: CalendarMonthOutlinedIcon,
      }}
    />
  );
});

export default DatePickerComponent;
